import { useState, useEffect, useRef} from 'react';
import { useNavigate, Routes, Route, useLocation, Navigate} from 'react-router-dom';
import { CurrentUserContext } from './context/CurrentUserContext';
import { LanguageProvider } from './context/LanguageContext.js';
import './App.css';
import api from './utils/API/MainApi.js';
/* import { loginFunction } from './utils/auth.js';
import SignInRedirect from './components/SignInRedirect/SignInRedirect.jsx'; */
import Header from './components/Header/Header';
import Home from './components/Home/Home';
import LoginPopup from './components/LoginPopup/LoginPopup.jsx';
import Signout from './components/Signout/Signout.jsx';
import ForgotPasswordPopup from './components/ForgotPassword/ForgotPassword.jsx';
import ResetPassword from './components/ResetPassword/ResetPassword.jsx';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import Upgrade from './components/Upgrade/Upgrade.jsx';
import Welcome from './components/Content/Welcome/Welcome.jsx';
import LevelContent from './components/Content/LevelContent.jsx';
import ProfileSidebar from './components/ProfileSideBar/ProfileSideBar.jsx';
import DashboardContent from './components/Content/DashboardContent/DashboardContent.jsx'
import VideosHome from './components/Content/VideosHome/VideosHome.jsx';
import ReaderHome from './components/Content/ReaderHome/ReaderHome.jsx';
/* import PDFCustomToolbarDemo from './components/Content/ReaderHome/test.jsx'; */
import UtilsHome from "./components/UtilsHome/UtilsHome.jsx";
import Utils from "./components/Utils/Ecocalendar/Ecocalendar.jsx"
import GlossarySection from './components/Glossary/Glossary.jsx';
import LoadingSpinner from './components/LoadingSpinner/LoadingSpinner.jsx';
import { levelContentData } from './components/Content/LevelContentData.js';
import { getAccessibleLevels } from './utils/accessibleLevels.js';
import MyNotes from './components/MyNotes/MyNotes.jsx';
import Admin from './components/Admin/Admin';
import AdminEditUser from './components/Admin/Components/AdminEditUser/AdminEditUser.jsx';
import Ecocalender from './components/Utils/Ecocalendar/Ecocalendar.jsx';
import AboutUs from './components/AboutUs/AboutUs.jsx';
import Courses from './components/Courses/Courses.jsx';
import Packages from './components/Content/Packages/Packages.jsx';
import Footer from './components/Footer/Footer.jsx';
import Terms from './components/Terms/Terms.jsx';
import Privacy from './components/Privacy/Privacy.jsx';
import ContactUs from './components/Contact/Contact.jsx';


function App() {
  const testUsers = {
    guest: { name: "guest", subscriptionLevel: 0 },
    basic: { name: "Santi", subscriptionLevel: 100 },
    intermediate: { name: "Abril", subscriptionLevel: 700 },
    admin: { name: "Admin", subscriptionLevel: 9999 },
  };

  const pagesRef = useRef(null);
  const navigate = useNavigate();
  const [selectedUserKey, setSelectedUserKey] = useState("guest");
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isLoginPopupOpen, setIsLoginPopupOpen] = useState(false);
  const [isSignOutPopupOpen, setIsSignOutPopupOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [currentUser, setCurrentUser] = useState({});
  
  const [isForgotPasswordOpen, setIsForgotPasswordOpen] = useState(false);
  const [notesUpdated, setNotesUpdated] = useState(0);
  
  //LANGUAGE 
/*  const { LanguageProvider } = useLanguage();

    useEffect(() => {
      document.documentElement.lang = language;
    }, [LanguageProvider]);
 */ 

/*   useEffect(() => {
    const user = testUsers[selectedUserKey];
    setCurrentUser(user); 
    setIsLoggedIn(user.subscriptionLevel > 0);
  }, [selectedUserKey]);
 */
  useEffect(() => {
    const token = localStorage.getItem('token');
  
    if (!token) {
      setIsLoading(false);
      return;
    }
  
    api.getMe(token)
      .then((user) => {
        const normalizedUser = {
          ...user,
          _id: user._id || user.id,
        };
        setCurrentUser(normalizedUser);
        localStorage.setItem('user', JSON.stringify(normalizedUser));
        setIsLoggedIn(true);

        if (window.location.pathname === '/') {
        if (normalizedUser.role === 9999) {
            navigate('/admin');
          } else {
            navigate('/welcome');
          }
        }
      })
      .catch((err) => {
        console.error("Token check failed:", err);
        localStorage.removeItem('token');
        setIsLoggedIn(false);
        setCurrentUser({ name: "guest", subscriptionLevel: 0 });
      })
      .finally(() => {
        setTimeout(() => setIsLoading(false), 750);
      });
  }, []);
  

  function handleOpenLoginPopupDesktop() { 
    setIsLoginPopupOpen(true);   }
  
  function handleOpenSignupPopupDesktop() {
    setIsSignOutPopupOpen(true); }

  function handleForgotPasswordClick() {
    setIsForgotPasswordOpen(true);     
    setIsLoginPopupOpen(false);        
  };


  function handleClosePopup() {  
    setIsLoginPopupOpen(false); 
    setIsSignOutPopupOpen(false);
    setIsForgotPasswordOpen(false);
  }

  function handleLogin({ email, password }) {
    api.login({ email, password })
      .then(data => {
        const token = data.token;
        localStorage.setItem('token', token);
        return api.getMe(token);
      })
      .then(user => {
        const normalizedUser = { ...user, _id: user._id || user.id };
        setCurrentUser(normalizedUser);

        localStorage.setItem('user', JSON.stringify(normalizedUser));
        setIsLoggedIn(true);
        setIsLoginPopupOpen(false);

        const from = window.location.pathname === '/' ? (normalizedUser.role === 9999 ? '/admin' : '/welcome') : window.location.pathname;
          navigate(from);
        })
        .catch(err => {
          console.error('Login error:', err.message);
        });
    }
    
  function handleSignOut() {
    localStorage.removeItem('token');
    setIsLoggedIn(false);
    setCurrentUser({ });
    navigate('/');
  }
 
  function handleEditProfile() {
    console.log("Edit Profile clicked");
  }
  
  function handleChangePassword() {
    console.log("Change Password clicked");
  }

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setCurrentUser(JSON.parse(storedUser));
    }
  }, []);
/*   useEffect(() => {
    fetch('http://localhost:4000/api/ping') //  
      .then(res => res.json())
      .then(data => console.log('Backend connected:', data))
      .catch(err => console.error('Backend NOT connected:', err));
  }, []); */

  return (
    <LanguageProvider>
      <CurrentUserContext.Provider value={{ currentUser, setCurrentUser, notesUpdated, setNotesUpdated}}>
        <div className="App">
          <Header
            isLoggedIn={isLoggedIn}
            onSignInPopupClick={handleOpenLoginPopupDesktop}
            onMobilePopupClick={() => setIsLoginPopupOpen(true)}
            onMobilePopupMenu={() => {}}
            onSignOutPopupClick={handleOpenSignupPopupDesktop}
            onMobileSignoutClick={() => setIsSignOutPopupOpen(true)}
            onMobileSignoutMenu={() => {}}
          />
          <LoginPopup 
            isOpen={isLoginPopupOpen}
            onClose={handleClosePopup}
            onLogin={handleLogin}
            handleForgotPasswordClick={handleForgotPasswordClick}
          />
          <ForgotPasswordPopup
            isOpen={isForgotPasswordOpen}
            onClose={handleClosePopup}
          />
          
          <Signout
          isOpen={isSignOutPopupOpen}
          onClose={handleClosePopup}
          onSignOut={handleSignOut}
          />
          
    

          <div className="pages" ref={pagesRef}>
            
            {/* development only*/}
          {/*  <div style={{ padding: "1rem", textAlign: "center" }}>
            <label style={{ marginRight: "0.5rem" }}>Switch Test User:</label>
            <select onChange={(e) => setSelectedUserKey(e.target.value)} value={selectedUserKey}>
              <option value="guest">Guest</option>
              <option value="basic">Basic</option>
              <option value="intermediate">Premium</option>
              <option value="admin">Admin</option>
            </select>
          </div> */}


            {isLoading ?  <LoadingSpinner/> : (
              <Routes>
                <Route path="/" element={<Home user={currentUser} />} />
                <Route path="/upgrade" element={<Upgrade />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/welcome"
                  element={
                    <ProtectedRoute user={currentUser} isLoggedIn={isLoggedIn} requiredLevel={100}>
                      <Welcome 
                        user={currentUser}  
                        setCurrentUser={setCurrentUser}  
                      />
                    </ProtectedRoute>
                  } 
                />
                <Route path="/aboutus" element={<AboutUs />}/>
                <Route path="/courses" element={<Courses />}/>
                <Route path="/packages" element={<Packages />}/>
                <Route path="/terms" element={<Terms />}/>
                <Route path="/privacy" element={<Privacy />}/>
                <Route path="/contactus" element={<ContactUs />}/>
                

                {/*<Route path="/onboarding" 
                    element={
                      <ProtectedRoute user={currentuser} isLoggedin={isLoggedIn} requiredLevel={100} onRequireLogin={() => setIsLoginPopupOpen(true)}>
                      { currentUser.role === 999
                       ?  <Navigate to="/admin" replace />
                       :  <Onboarding user={currentUser} setCurrentUser={setCurrentUser} />
                      }
                    }
                */}
                <Route path="/content"
                  element={
                    <ProtectedRoute user={currentUser} isLoggedIn={isLoggedIn} requiredLevel={100}   onRequireLogin={() => setIsLoginPopupOpen(true)}>
                      { currentUser.role === 9999 
                      ? <Navigate to="/admin" replace />
                      : <LevelContent user={currentUser} setCurrentUser={setCurrentUser} />
                      }
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/profile"
                  element={
                      <ProtectedRoute user={currentUser} isLoggedIn={isLoggedIn} requiredLevel={100} >
                      <ProfileSidebar
                        setCurrentUser={setCurrentUser}
                        levelContentData={levelContentData}
                        onEditProfile={handleEditProfile}
                        onChangePassword={handleChangePassword}
                      />
                      
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/dashboard" 
                  element={
                    <ProtectedRoute user={currentUser} 
                    isLoggedIn={isLoggedIn}  
                    requiredLevel={100}>
                      <DashboardContent user={currentUser} />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/videos/:videoSlug" element={
                    <ProtectedRoute user={currentUser} isLoggedIn={isLoggedIn} requiredLevel={100}>
                      <VideosHome user={currentUser}
                      accessibleLevels={getAccessibleLevels(currentUser)}
                    />
                    </ProtectedRoute>
                  }
                />
                
                <Route
                  path="/docs/:pdfSlug" element={
                    <ProtectedRoute user={currentUser} isLoggedIn={isLoggedIn} requiredLevel={100}>
                      <ReaderHome user={currentUser} 
                      accessibleLevels={getAccessibleLevels(currentUser)}
                      />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/docs" element={
                    <ProtectedRoute user={currentUser} isLoggedIn={isLoggedIn} requiredLevel={100}>
                      <ReaderHome user={currentUser} 
                      accessibleLevels={getAccessibleLevels(currentUser)}
                      />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/utils/" element={
                    <ProtectedRoute user={currentUser} isLoggedIn={isLoggedIn} equiredLevel={100}>
                      <UtilsHome user={currentUser} />
                      {/* <Ecocalender /> */}
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/utils/glossary" element={
                    <ProtectedRoute user={currentUser} isLoggedIn={isLoggedIn} requiredLevel={100}>
                      <GlossarySection/>
                    </ProtectedRoute>
                  }
                />
                <Route 
                  path="/notes" element={
                    <ProtectedRoute user={currentUser} isLoggedIn={isLoggedIn} requiredLevel={100}>
                      <MyNotes />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin"
                  element={
                    <ProtectedRoute user={currentUser} isLoggedIn={isLoggedIn} requiredLevel={9999}>
                      <Admin />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin/users/:id"
                  element={
                    <ProtectedRoute user={currentUser} isLoggedIn={isLoggedIn} requiredLevel={9999}>
                      <AdminEditUser />
                    </ProtectedRoute>
                  }
                />
              </Routes>

            )}
          </div>
          <Footer />
        </div>
      </CurrentUserContext.Provider>
    </LanguageProvider>
  );
}

export default App;
